// Diretta (Live Match) Types

export interface Match {
  match_id: string;
  id?: number;
  home_team: TeamInfo;
  away_team: TeamInfo;
  score_home: number;
  score_away: number;
  date: string;
  time: string;
  status: 'scheduled' | 'live' | 'finished';
  minute?: string;
  competition?: string;
  matchday?: string;
  venue?: string;
}

export interface TeamInfo {
  name: string;
  logo?: string;
  short_name?: string;
}

export interface Commentary {
  id: number;
  match_id: string;
  comment_time: string | null;
  comment_class: CommentaryType;
  comment_text: string;
  is_bold: boolean;
  is_important: boolean;
  created_at?: string;
}

export type CommentaryType =
  | 'soccer-ball'   // Goal/action
  | 'corner'        // Corner kick
  | 'lineup1'       // Starting lineup
  | 'whistle'       // Kickoff/halftime/fulltime
  | 'y-card'        // Yellow card
  | 'r-card'        // Red card
  | 'yr-card'       // Second yellow (red)
  | 'substitution'  // Substitution
  | 'funfact'       // Info/neutral
  | 'penalty'       // Penalty
  | 'var'           // VAR check
  | 'time'          // Added time
  | 'injury'        // Injury
  | 'attendance';   // Attendance

export const COMMENTARY_ICONS: Record<CommentaryType, string> = {
  'soccer-ball': '⚽',
  'corner': '🚩',
  'lineup1': '👕',
  'whistle': '🏁',
  'y-card': '🟡',
  'r-card': '🔴',
  'yr-card': '🟡🔴',
  'substitution': '🔄',
  'funfact': '💬',
  'penalty': '⚠️',
  'var': '📺',
  'time': '⏱️',
  'injury': '🩹',
  'attendance': '🏟️',
};

export interface MatchStats {
  possession_home: number;
  possession_away: number;
  shots_home: number;
  shots_away: number;
  shots_on_target_home: number;
  shots_on_target_away: number;
  corners_home: number;
  corners_away: number;
  fouls_home: number;
  fouls_away: number;
  offsides_home: number;
  offsides_away: number;
  yellow_cards_home: number;
  yellow_cards_away: number;
  red_cards_home: number;
  red_cards_away: number;
}

export interface Lineup {
  home: LineupTeam;
  away: LineupTeam;
}

export interface LineupTeam {
  formation: string;
  players: Player[];
  substitutes: Player[];
  coach?: string;
}

export interface Player {
  number: number;
  name: string;
  short_name?: string;
  position?: string;
  image?: string;
  rating?: number;
  captain?: boolean;
  player_id?: string; // FlashLive player ID for matching incidents
}

export interface ChatMessage {
  id: number;
  user_id: number;
  user_name?: string;
  user_avatar?: string;
  message: string;
  created_at: string;
  is_redazione?: boolean;
  is_pinned?: boolean;
  // API returns member object
  member?: {
    username?: string;
    first_name?: string;
    last_name?: string;
  };
  reply_to?: {
    id: number;
    user_name: string;
    message: string;
  };
  reactions?: {
    [emoji: string]: number[];
  };
}

export interface GCSSignal {
  match_id: string;
  updated: number;
  date?: string;
}
